import React, { useState } from "react";
import { Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton } from "@chakra-ui/react";
import Select from "react-select";
import { Checkbox } from "@chakra-ui/react";
import { stringComponent } from "../utils/SearchPickList";
import { FaStar } from "react-icons/fa6";
import { getProductReviewApi } from "../../../redux/reduxApi/admin/ProductReviewApi";
import { useDispatch } from "react-redux";
const reviewStatus = [
  { value: false, label: "Unapproved", bgColor: "green" },
  { value: true, label: "Approved", bgColor: "red" },
];
export default function ReviewSearch(props) {
  const { closeDrawer } = props;
  const [isProductNameChecked, SetIsProductNameChecked] = useState(false);
  const [ProductSelectedOption, setProductSelectedOption] = useState({
    label: "Is",
    value: "is",
  });
  const [ShowProductNameInput, setShowProductNameInput] = useState(false);
  const [productNameValue, setProductNameValue] = useState("");
  const [customerSelectedOption, setCustomerSelectedOption] = useState({
    label: "Is",
    value: "is",
  });
  const [statusSelectedOption, setStatusSelectedOption] = useState("");
  const [isCustomerNameChecked, SetIsCustomerNameChecked] = useState(false);
  const [isStatusChecked, SetIsStatusChecked] = useState(false);
  const [ShowCustomerNameInput, setShowCustomerNameInput] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [statusValues, setStatusValues] = useState([]);
  const [isRatingChecked, SetIsRatingChecked] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);
  const handleOnClose = () => {
    closeDrawer();
    SetIsCustomerNameChecked(false);
    SetIsStatusChecked(false);
    SetIsProductNameChecked(false);
    SetIsRatingChecked(false);
    setCustomerName(" ");
    setSelectedRating(0);
  };

  // for Product name
  const handleProductName = (e) => {
    SetIsProductNameChecked(e.target.checked);
    setShowProductNameInput(true);
    if (!e.target.checked) {
      setProductSelectedOption({ label: "Is", value: "is" });
      setShowProductNameInput(false);
    }
  };
  const handleProductSelectChange = (selected) => {
    const selectedValue = selected.value;
    setProductSelectedOption(selected);
    if (["is", "is-not", "starts-with", "ends-with", "like", "contains", "not-contains"].includes(selectedValue)) {
      setShowProductNameInput(true);
    } else {
      setShowProductNameInput(false);
    }
  };
  // for customer name
  const handleCustomerName = (e) => {
    SetIsCustomerNameChecked(e.target.checked);
    setShowCustomerNameInput(true);
    if (!e.target.checked) {
      setCustomerSelectedOption({ label: "Is", value: "is" });
      setCustomerName("");
    }
  };
  const handleCustomerSelectChange = (selected) => {
    const selectedValue = selected.value;
    setCustomerSelectedOption(selected);
    console.log("value", selectedValue);
    if (
      selectedValue === "is" ||
      selectedValue === "is-not" ||
      selectedValue === "starts-with" ||
      selectedValue === "ends-with" ||
      selectedValue === "like" ||
      selectedValue === "contains" ||
      selectedValue === "not-contains"
    ) {
      setShowCustomerNameInput(true);
    } else {
      setShowCustomerNameInput(false);
    }
  };

  const handleCustomerNameInputChange = (e) => {
    setCustomerName(e.target.value);
  };

 const handleReset = () => {
  // Reset Product Name
  SetIsProductNameChecked(false);
  setProductSelectedOption({ label: "Is", value: "is" });
  setShowProductNameInput(false);
  setProductNameValue("");
  
  // Reset Customer Name
  SetIsCustomerNameChecked(false);
  setCustomerSelectedOption({ label: "Is", value: "is" });
  setShowCustomerNameInput(false);
  setCustomerName("");
  
  // Reset Status
  SetIsStatusChecked(false);
  setStatusSelectedOption("");
  setStatusValues([]);
  
  // Reset Rating
  SetIsRatingChecked(false);
  setSelectedRating(0);
};

  // for status field
  const handleStatusCheckbox = (e) => {
    SetIsStatusChecked(e.target.checked);
    if (!e.target.checked) {
      setStatusSelectedOption("");
      setStatusValues();
    }
  };
  const handleStatusSelectChange = (selected) => {
    setStatusSelectedOption(selected);
    setStatusValues(selected.value);
  };
  // for Rating field
  const handleRatingCheckbox = (e) => {
    SetIsRatingChecked(e.target.checked);
    if (!e.target.checked) {
      // setRatingSelectedOption("");
      // setRatingValues([]);
    }
  };
  // const handleRatingSelectChange = (selected) => {
  //     setRatingSelectedOption(selected);
  //     setRatingValues(selected.map((option) => option.value));
  // };

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const searchFilters = [];

    const addFilter = (field, operation, value) => {
      if (value && (Array.isArray(value) ? value.length : true)) {
        searchFilters.push({ field, operation, value });
      }
    };

    // Tag filter
    if (isProductNameChecked) {
      addFilter("productName", ProductSelectedOption.value, productNameValue);
    }

    // Module filter
    if (isCustomerNameChecked) {
      addFilter("customerName", customerSelectedOption.value, customerName);
    }

    if (isStatusChecked) {
      addFilter("verified", "is", statusValues);
    }

    if (isRatingChecked) {
      addFilter("rating", "is", selectedRating);
    }

    const requestBody = {
      search: searchFilters,
    };

    console.log("Search Final data:", requestBody);
    try {
      const response = await dispatch(getProductReviewApi(requestBody));
      // console.log("Filter results:", response.payload.data);
    } catch (error) {
      console.error("Error fetching filter results:", error);
    }
  };

  return (
    <Drawer isOpen={props.isSearchDrawerOpen} placement="right" size="xs" onClose={handleOnClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader> <div className="d-flex justify-content-start align-items-center gap-4">
            <span>Search Product Review</span>
   <button className="reset-btn mr-12" onClick={handleReset}> Reset</button>

             
</div> </DrawerHeader>
        <DrawerBody>
          <div className=" mb-4 p-0" style={{ backgroundColor: "#FFFFFF" }}>
            <div className="card-body p-0">
              <form>
                {/* for 
                    {/* for Product name */}
                <div className="ProductName mt-2">
                  <div className="d-flex gap-3">
                    <Checkbox onChange={handleProductName}>Product Name</Checkbox>
                  </div>
                  {isProductNameChecked && (
                    <div className="mt-2 w-100">
                      <Select options={stringComponent} value={ProductSelectedOption} onChange={handleProductSelectChange} />
                    </div>
                  )}
                  {isProductNameChecked && ShowProductNameInput && (
                    <input type="text" className="form-control mt-2" placeholder="Product Name" value={productNameValue} onChange={(e) => setProductNameValue(e.target.value)} />
                  )}
                </div>
                {/* for customer name */}
                <div className="CustomerName mt-2">
                  <div className="d-flex gap-3">
                    <Checkbox onChange={handleCustomerName}>Customer Name</Checkbox>
                  </div>
                  {isCustomerNameChecked && (
                    <div className="mt-2 w-100">
                      <Select options={stringComponent} value={customerSelectedOption} onChange={handleCustomerSelectChange} />
                    </div>
                  )}
                  {isCustomerNameChecked && ShowCustomerNameInput && (
                    <input type="text" class="form-control mt-2" placeholder=" Customer Name" value={customerName} onChange={handleCustomerNameInputChange} />
                  )}
                </div>
                {/* for status  */}
                <div className="Status mt-2">
                  <div className="d-flex gap-3">
                    <Checkbox onChange={handleStatusCheckbox}>Status</Checkbox>
                  </div>
                  {isStatusChecked && (
                    <div className="mt-2 w-100">
                      <Select options={reviewStatus} value={statusSelectedOption} onChange={handleStatusSelectChange} />
                    </div>
                  )}
                </div>
                {/* for Rating  */}
                <div className="Rating mt-2">
                  <div className="d-flex gap-3">
                    <Checkbox onChange={handleRatingCheckbox}>Rating</Checkbox>
                  </div>
                  {isRatingChecked && (
                    <div className="mt-2 w-100 rounded border-1 border-gray-300 px-1 py-2.5">
                      <div className="flex items-center gap-1">
                        {[...Array(5)].map((_, i) => (
                          <FaStar
                            key={i}
                            className={i < selectedRating ? "text-yellow-500 cursor-pointer" : "text-gray-300 cursor-pointer"}
                            onClick={() => setSelectedRating(i + 1)} // Set the rating when a star is clicked
                          />
                        ))}
                      </div>
                      <p className="mt-2">Selected Rating: {selectedRating}</p>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </DrawerBody>
        <DrawerFooter style={{ display: "block" }} className="">
          <div className="gap-3 flex justify-center">
            <button variant="outline" mr={3} className="cancel-button" onClick={handleOnClose}>
              Cancel
            </button>
            <button className="main-btn" onClick={handleSubmit}>
            <span className='inner-content'>Search</span>
            </button>
          </div>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
